import { render } from "./CopySnippet.vue?vue&type=template&id=476c2873"
import script from "./CopySnippet.vue?vue&type=script&lang=js"
export * from "./CopySnippet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__